import * as swcHelpers from '@swc/helpers';
import '../../../../../types/product.js';
import { SINGLE_PURCHASE } from '../../../../../types/purchase-types.js';
import 'react';
import '@grandvisionhq/state';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import '../../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/forms';
import '@grandvisionhq/analytics';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-visuals';
import '@grandvisionhq/inventory';
import '../../../../../slots/context.js';
import '@grandvisionhq/lib-cookies';
import '@grandvisionhq/content';
import { WITHOUT_RX, WITH_RX } from '../../../components/RxableSelect/contants.js';
import '@grandvisionhq/lib-utils-html';
import { getMaxSelectableQuantity } from '../../utils/get-max-selectable-quantity.js';
import { getRxEntryType } from '../../utils/get-rx-entry-type.js';

const getInitialState = ({ sortedAttributesSet , maxOrderableQuantity , defaultDeliveryInterval  })=>{
    const defaultPurchaseType = SINGLE_PURCHASE;
    /**
   * The available quantity and allowBackOrder prop on the master variant does not need to be
   * checked here, because CL are always shown as orderable on first render
   *
   * Once a CL is fetched, the allowBackOrder status and available quantity will be updated.
   */ const maxSelectableQuantity = getMaxSelectableQuantity({
        allowBackOrder: true,
        maxOrderableQuantity
    });
    /**
   * Set the default value for each dropdown attribute.
   * If there is only 1 option in the list, set the value to that option
   * Otherwise, set the value to null
   */ const rxAttributeDefaults = sortedAttributesSet.reduce((acc, { name , attributeOptions  })=>{
        if (Object.keys(attributeOptions).length === 1) {
            return swcHelpers.objectSpread({}, acc, {
                [name]: Object.values(attributeOptions)[0]
            });
        }
        return swcHelpers.objectSpread({}, acc, {
            [name]: null
        });
    }, {});
    const allAttributesAreFilledIn = !Object.values(rxAttributeDefaults).some((defaultValue)=>defaultValue === null
    );
    const rxEntryType = getRxEntryType(sortedAttributesSet);
    const rxToggle = rxEntryType === 'no-rx-entry' ? WITHOUT_RX : WITH_RX;
    const columnConfigurationsDefaults = {
        prescription: rxAttributeDefaults,
        quantity: 1
    };
    const columnUIDefaults = {
        isValid: allAttributesAreFilledIn,
        isEnabled: true,
        quantitySelector: {
            maxSelectableQuantity,
            selectionInvalidatedCount: undefined
        }
    };
    return {
        configurations: {
            purchaseType: defaultPurchaseType,
            rxToggle,
            left: columnConfigurationsDefaults,
            right: columnConfigurationsDefaults,
            both: columnConfigurationsDefaults,
            subscriptionPurchaseConfigurations: {
                deliveryInterval: defaultDeliveryInterval !== null && defaultDeliveryInterval !== void 0 ? defaultDeliveryInterval : null
            }
        },
        queries: {
            left: {
                sku: undefined
            },
            right: {
                sku: undefined
            },
            both: {
                sku: undefined
            }
        },
        configurator: {
            rxEntryType,
            invalidSubmissionsCount: undefined,
            isConfiguratorValid: allAttributesAreFilledIn,
            left: columnUIDefaults,
            right: columnUIDefaults,
            both: columnUIDefaults,
            columns: {
                areValid: allAttributesAreFilledIn,
                showError: false
            },
            columnCheckboxes: {
                areValid: columnUIDefaults.isEnabled,
                showError: false
            },
            deliveryInterval: {
                isValid: defaultDeliveryInterval ? true : undefined,
                showError: false
            }
        }
    };
};

export { getInitialState };
//# sourceMappingURL=get-initial-state.js.map
